import React from 'react'

import {
  AlignItems,
  Body2,
  Box,
  Color,
  Display,
  FontWeight,
  Icon,
  IconVariant,
} from '@gousto-internal/citrus-react'

// Render as a pill when the screen is wide enough, otherwise render as a full-width bar
// The pill is used in the OrderConfirmationHeader, and the bar is used in the OrderConfirmation component
export const DISCOUNT_BANNER_BREAKPOINT_PX = 740

type DiscountSavingsBannerVariant = 'pill' | 'bar'

type DiscountSavingsBannerProps = {
  percentage: string
  amountSaved: string
  variant: DiscountSavingsBannerVariant
}

export const DiscountSavingsBanner = ({
  percentage,
  amountSaved,
  variant,
}: DiscountSavingsBannerProps) => {
  const isPill = variant === 'pill'

  return (
    <Box
      data-testid={isPill ? 'discountSavingsPill' : 'discountSavingsBar'}
      display={Display.Flex}
      alignItems={AlignItems.Center}
      gap={2}
      paddingH={3}
      bg={Color.Success_900}
      color={Color.White}
      width={isPill ? undefined : '100%'}
      minHeight="28px"
      style={{ borderRadius: '8px' }}
    >
      <Icon name="tick" size={4} variant={IconVariant.Inherit} />
      <Body2 size={2} fontWeight={FontWeight.Bold} color={Color.White}>
        {percentage} discount applied
      </Body2>
      <Body2 size={2} color={Color.White}>
        •
      </Body2>
      <Body2 size={2} color={Color.White}>
        Saved {amountSaved}
      </Body2>
    </Box>
  )
}
